<!-- @if (!showToolbar) {
 <app-add-popup (newElement)="addNewElement($event)"></app-add-popup>
} -->

<!-- @if (showToolbar) { -->
<!-- <app-toolbar></app-toolbar> -->
<!-- } -->

<div class="card">
  <p-table
    #dt
    [columns]="_selectedColumns"
    [value]="tableBody"
    selectionMode="multiple"
    [(selection)]="selectedProducts"
    [exportHeader]="'customExportHeader'"
    [metaKeySelection]="metaKey"
    [scrollable]="true"
    scrollHeight="500px"
    [virtualScroll]="true"
    [virtualScrollItemSize]="46"
    dataKey="id"
    editMode="row"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template pTemplate="caption">
      <div style="text-align: left">
        <p-button icon="pi pi-external-link" label="Export" (click)="dt.exportCSV()" />
        <p-button icon="pi pi-plus" label="Ajouter" (click)="addnewLine()" />
        <p-multiSelect [options]="tableHeader" [(ngModel)]="_selectedColumns" placeholder="Colonne(s) à afficher" [style]="{ float: 'right' }"> </p-multiSelect>
      </div>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <!-- Header Names -->
      <tr>
        @for (col of columns; track col) {
          <th id="table-header" (click)="selectColumn(col)">
            {{ col }}
          </th>
        }
        <th>Edit</th>
      </tr>

      <!-- Filter Inputs -->
      <tr>
        @for (col of columns; track $index) {
          <th id="table-filter-input">
            <p-columnFilter type="text" field="{{ col }}" placeholder="Filter {{ col }}" ariaLabel="Filter {{ col }}" />
          </th>
        }
        <td></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-editing="editing" let-ri="rowIndex" let-rowData let-columns="columns">
      <!-- Body Rows -->
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (dblclick)="onRowEditInit(rowData)" (click)="selectData(rowData)">
        <!-- Add new line cell -->
        @if (newLineButton) {
          @for (col of columns; track $index) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input"> </ng-template>
              </p-cellEditor>
            </td>
          }
        }

        @for (col of columns; track $index) {
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <div class="card flex flex-column md:flex-row gap-3">
                  @switch (col.type) {
                    @case ('button') {
                      <p-button label="{{ rowData[col] }}" name="button" [disabled]="col.isDisabled" />
                      <p-inputGroup> </p-inputGroup>
                    }
                    @case ('checkbox') {
                      <p-inputGroup>
                        <p-checkbox [(ngModel)]="checked" [binary]="true" inputId="binary" name="radioButton" [disabled]="col.isDisabled" label="{{ [rowData[col]] }}" />
                      </p-inputGroup>
                    }
                    @case ('date') {
                      <div class="card flex justify-content-center">
                        <p>{{ date }}</p>
                        <p-calendar [(ngModel)]="date" [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false" dateFormat="dd.mm.yy" [disabled]="col.isDisabled" />
                      </div>
                    }
                    @case ('text') {
                      <p-inputGroup>
                        <p-inputGroupAddon>
                          <i class="pi pi-user"></i>
                        </p-inputGroupAddon>
                        <input pInputText type="text" [(ngModel)]="rowData[col]" [disabled]="col.isDisabled" />
                      </p-inputGroup>
                    }
                    @default {
                      <p>{{ rowData[col.field] }}</p>
                      <div class="card flex justify-content-center">
                        <input pInputText type="text" [(ngModel)]="rowData[col]" [disabled]="col.isDisabled" />
                      </div>
                    }
                  }
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                <!-- {{ rowData[col] }} = {{ col | json }} -->
                @if (rowData[col] == '[object Object]') {
                  @for (item of col; track $index) {
                    {{ rowData[col] }}
                  }
                  <!-- {{ rowData[col] }} -->
                } @else {
                  {{ rowData[col] }}
                  <!-- {{ rowData[col] }} = {{ col | json }} -->
                }
              </ng-template>

              <!-- <ng-template pTemplate="input"> -->
              <!-- <input pInputText type="{{col.type}}" [(ngModel)]="rowData[col.field]" /> -->
              <!-- </ng-template> -->
              <!-- <ng-template pTemplate="output"> -->
              <!-- {{ rowData[col.field] }} -- {{col.type}} -->
              <!-- </ng-template> -->
            </p-cellEditor>
          </td>
        }
        <td>
          <div class="flex align-items-center justify-content-center gap-2">
            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(rowData)" class="p-button-rounded p-button-text"></button>
            <p-button *ngIf="!editing" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" size="small" (onClick)="deleteRow(rowData)" />
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(rowData)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(rowData, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">Nombre de résultat : {{ tableBody ? tableBody.length : 0 }}</div>
    </ng-template>
  </p-table>
</div>
